import { BalanceType } from 'app/dataTypes/cafeteria/compensation/balance'

import type { Request } from '../../../index'


export type ResultApi = {
  balance: number,
}

export type Params = {
  studentID: string
  supplierID: string
}

export type ParamsApi = {
  student_id: number
  food_supplier_id: number
}

export const convertParams = ({
  studentID,
  supplierID,
}: Params): [ParamsApi, null] => {
  return [{
    student_id: parseInt(studentID, 10),
    food_supplier_id: parseInt(supplierID, 10),
  }, null]
}
export const convertResult = (apiData: ResultApi): BalanceType => {
  return apiData
}

export const GET_COMPENSATION_BALANCE: Request<Params, BalanceType, void> = [
  'cabinet/compensation/balance',
  'get',
  ['data'],
]
